import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import { IAccountingUser } from '@/interfaces';
import routes from '@/lib/routes';

type TDataVariables = Omit<IAccountingUser, 'createdAt' | 'updatedAt' | '_id' | 'createdByUserId'>;
type TResponseData = IAccountingUser;

export const useRequestCreateAccountingUser = () => {

    const { invalidate } = useInvalidateQueries();
    const { isPending, error, mutateAsync } = useMutation({
        mutationKey: [routes.api.accountingUsers, 'create'],
        mutationFn: (data: TDataVariables) =>
            apiClient
                .post<TResponseData>(routes.api.accountingUsers, data)
                .then(handleApiResponse),
        onSuccess: () => { void invalidate(routes.api.accountingUsers); }
    });

    const trigger = (data: TDataVariables) =>
        mutateAsync(data);

    return ({
        isLoading: isPending,
        trigger,
        error
    });

};
